import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { AppModule } from './app/app.module';
import * as Sentry from "@sentry/angular";
import { environment } from './environments/environment';

if (environment.production) {
  enableProdMode();
}

Sentry.init({
  dsn: "https://6d06b0ae23c8f69afeadc811445a98d8@o4509685402894336.ingest.us.sentry.io/4509685523480577",
  environment: environment.production ? 'production' : 'development',
  release: 'dealer-portal-angular@1.0.0'
});

platformBrowserDynamic().bootstrapModule(AppModule)
  .catch((err) => console.error(err));
